import { Component, OnInit } from '@angular/core';
import { Settings } from '../settings/settings';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { RegistryService } from '../registry/registry.service';
import { AuthService, User } from '../user/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { PaymentService } from '../payment/payment.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-stripe-guide',
  templateUrl: './mini-thanks.component.html',
  styleUrls: ['./mini-thanks.component.scss']
})
export class MiniThanksComponent implements OnInit {
  registry: RegistryFirebaseService;
  settings: Settings
  user: User;
  showSendText =false;
  disabledQuickThanks: boolean = false;
  showSaveButton: boolean = false;
  private initialQuickThanksState: boolean = false;

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private _route: ActivatedRoute,
    private _router: Router,
    private paymentService: PaymentService




  ) { }
  defaulTtitle = "Thank you for your contribution!";
  defaultDescription = "Thank you so much for your generous contribution towards our adventure of a lifetime. Our hearts are filled with joy and gratitude as we embark on our new journey together. With your thoughtful gift, we are excited to make more amazing memories and create unforgettable experiences.";
  title: string = "Thank you for your contribution!";
  description: string = "Thank you so much for your generous contribution towards our adventure of a lifetime. Our hearts are filled with joy and gratitude as we embark on our new journey together. With your thoughtful gift, we are excited to make more amazing memories and create unforgettable experiences.";
  showReset = false;



  ngOnInit() {



    this._registryService.setScrollY(1);
    this.registry = this._route.snapshot.data.registry;
    this.settings = this._route.snapshot.data.settings;
    this.user = this._route.snapshot.data.user;
    this.initFields(this.settings);
 
    this._authService.authToken().subscribe(token => {

    })

    this._registryFirebaseService.killLoader();  

this._registryFirebaseService.getSettings().subscribe((settings: Settings) => {
  this.initFields(settings);
  if (settings && typeof settings.disabledQuickThanks === 'boolean') {
    this.disabledQuickThanks = settings.disabledQuickThanks;
    this.initialQuickThanksState = settings.disabledQuickThanks;
  }

  if(!this.title && !this.disabledQuickThanks){
    this.title = this.defaulTtitle;
  } 
  
  if (!this.description && !this.disabledQuickThanks){
    this.description = this.defaultDescription;
  }
})
  
  }

  private initFields(settings: Settings) {
  if(!settings) {return;}


    this.settings = settings;
    this.title = this.settings.emailTitleOverride;
    this.description = this.settings.emailDescriptionOverride;


  
    this.showReset = false;
  }

  back(){
    this._router.navigate(['/registry/' ]);
  }

  resetDefaults(){
    this.title = this.defaulTtitle;
    this.description = this.defaultDescription; 
    this.showReset = false;
  }

  checkIfShouldShowReset(){
    this.showReset = false;
    if (this.title !== this.defaulTtitle || 
        this.description !== this.defaultDescription ||
        this.disabledQuickThanks !== this.initialQuickThanksState) {
      this.showReset = true;
    }
  }

  save(){
    if (!this.settings) {
      return;
    }
    
    this.settings.emailTitleOverride = this.title;
    this.settings.emailDescriptionOverride = this.description;
    this.settings.disabledQuickThanks = this.disabledQuickThanks;
    
    this._registryFirebaseService.saveSettings(this.settings);
    this.showSaveButton = false;
    this.initialQuickThanksState = this.disabledQuickThanks;
    this._registryService.emitGenericToastMsg("Quick Thanks Saved");


  }

  sendTextEmail() {



    try{
    let fbToken = null;
    this._authService.authToken().pipe(
      take(1),
      tap(token => {
        fbToken = token;
        this.showSendText = false
        this._registryService.emitGenericToastMsg("Test email sent to "+ this.user.email);
        (window as any).grecaptcha.execute('6LeRGRUpAAAAAE7lY2q9SzI3OjafICtmjTzPEPyc', {action: 'submit'}).then((recaptchaToken) => {
          this.paymentService.sendTextGuestEmail(recaptchaToken, fbToken).subscribe((res)=>{

          })
        });
      })
    ).subscribe();
  
    }
    catch(e){
    }
  }

  onCheckled(currentValue: boolean | undefined) {
    if (currentValue === undefined || currentValue === null) {
      currentValue = false;
    }
    this.disabledQuickThanks = !currentValue;
    
    this.settings.disabledQuickThanks = this.disabledQuickThanks;
    if (this.settings.disabledQuickThanks){
      this.description = "";
      this.title = "";
    } else {
      if(!this.description){
        this.description = this.defaultDescription;
      }
      if(!this.title){
        this.title = this.defaulTtitle;
      }
    }

    this.checkIfShouldShowReset();
  }

}



// WEBPACK FOOTER //
// ./src/app/mini-thanks/mini-thanks.component.ts